import { registerNotification } from './registry'

registerNotification('script:error', {
  color: (_, theme) => theme.semantic.negative,
  icon:  () => 'error-full',
})